var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEscada(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-335"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M481.65,451.43H11.1a.51.51,0,0,1-.5-.5.5.5,0,0,1,.5-.5H481.65a.5.5,0,0,1,.5.5A.5.5,0,0,1,481.65,451.43Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arrows--inject-335"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 33.62,
    width: 59.61,
    height: 48.8,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.6,82.92H126a.5.5,0,0,1-.5-.5V33.62a.5.5,0,0,1,.5-.5h59.6a.5.5,0,0,1,.5.5v48.8A.5.5,0,0,1,185.6,82.92Zm-59.1-1h58.6V34.12H126.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.03 64.99 155.8 39.21 138.57 64.99 144.38 64.99 144.38 76.72 167.22 76.72 167.22 64.99 173.03 64.99",
    style: {
      fill: "#3010BC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.22,77.22H144.38a.5.5,0,0,1-.5-.5V65.49h-5.31a.5.5,0,0,1-.44-.27.49.49,0,0,1,0-.51l17.24-25.78a.52.52,0,0,1,.83,0l17.23,25.78a.49.49,0,0,1,0,.51.48.48,0,0,1-.44.27h-5.31V76.72A.5.5,0,0,1,167.22,77.22Zm-22.34-1h21.84V65a.5.5,0,0,1,.5-.5h4.88L155.8,40.11,139.51,64.49h4.87a.5.5,0,0,1,.5.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.13,
    y: 33.62,
    width: 59.61,
    height: 48.8,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.74,82.92H417.13a.5.5,0,0,1-.5-.5V33.62a.51.51,0,0,1,.5-.5h59.61a.5.5,0,0,1,.5.5v48.8A.5.5,0,0,1,476.74,82.92Zm-59.11-1h58.61V34.12H417.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "464.17 64.99 446.94 39.21 429.71 64.99 435.52 64.99 435.52 76.72 458.36 76.72 458.36 64.99 464.17 64.99",
    style: {
      fill: "#3010BC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.36,77.22H435.52a.5.5,0,0,1-.5-.5V65.49h-5.31a.48.48,0,0,1-.44-.27.49.49,0,0,1,0-.51l17.23-25.78a.52.52,0,0,1,.83,0l17.24,25.78a.49.49,0,0,1,0,.51.5.5,0,0,1-.44.27h-5.31V76.72A.5.5,0,0,1,458.36,77.22Zm-22.34-1h21.84V65a.5.5,0,0,1,.5-.5h4.87L446.94,40.11l-16.3,24.38h4.88a.5.5,0,0,1,.5.5Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Ladder--inject-335"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M304.21,455.32a2.5,2.5,0,0,1-2.5-2.5V41.36a2.5,2.5,0,0,1,5,0V452.82A2.5,2.5,0,0,1,304.21,455.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.5,455.32a2.5,2.5,0,0,1-2.5-2.5V41.36a2.5,2.5,0,0,1,5,0V452.82A2.5,2.5,0,0,1,405.5,455.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.5,68.4h-100a2.5,2.5,0,1,1,0-5h100a2.5,2.5,0,0,1,0,5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.5,123.13h-100a2.5,2.5,0,0,1,0-5h100a2.5,2.5,0,0,1,0,5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.5,177.87h-100a2.5,2.5,0,0,1,0-5h100a2.5,2.5,0,0,1,0,5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.5,232.6h-100a2.5,2.5,0,0,1,0-5h100a2.5,2.5,0,0,1,0,5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.5,287.34h-100a2.5,2.5,0,0,1,0-5h100a2.5,2.5,0,0,1,0,5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.5,342.07h-100a2.5,2.5,0,0,1,0-5h100a2.5,2.5,0,0,1,0,5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.5,396.81h-100a2.5,2.5,0,0,1,0-5h100a2.5,2.5,0,0,1,0,5Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Elevator--inject-335"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 52.09,
    y: 89.46,
    width: 207.41,
    height: 361.47,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.51,451.43H52.09a.51.51,0,0,1-.5-.5V89.46a.5.5,0,0,1,.5-.5H259.51a.5.5,0,0,1,.5.5V450.93A.51.51,0,0,1,259.51,451.43Zm-206.92-1H259V90H52.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.4,
    y: 97.98,
    width: 188.8,
    height: 352.94,
    style: {
      fill: "#b2b2b2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.2,451.43H61.4a.51.51,0,0,1-.5-.5V98a.51.51,0,0,1,.5-.5H250.2a.5.5,0,0,1,.5.5v353A.5.5,0,0,1,250.2,451.43Zm-188.3-1H249.7V98.48H61.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.8,451.43a.5.5,0,0,1-.5-.5V98.61a.5.5,0,0,1,1,0V450.93A.5.5,0,0,1,155.8,451.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 245.08,
    y1: 115.07,
    x2: 186.31,
    y2: 173.84,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.31,174.34a.5.5,0,0,1-.35-.85l58.77-58.78a.5.5,0,0,1,.71.71l-58.77,58.77A.51.51,0,0,1,186.31,174.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 243.23,
    y1: 124.36,
    x2: 235.1,
    y2: 132.49,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.1,133a.51.51,0,0,1-.36-.15.5.5,0,0,1,0-.7l8.13-8.13a.5.5,0,0,1,.71,0,.48.48,0,0,1,0,.7l-8.13,8.13A.5.5,0,0,1,235.1,133Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 73.6,
    y1: 399.97,
    x2: 98.94,
    y2: 374.62,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6,400.47a.51.51,0,0,1-.36-.15.5.5,0,0,1,0-.7l25.35-25.35a.5.5,0,0,1,.71.71L74,400.32A.5.5,0,0,1,73.6,400.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 86.74,
    y1: 392.4,
    x2: 111.23,
    y2: 367.92,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.74,392.9a.5.5,0,0,1-.35-.85l24.49-24.49a.5.5,0,0,1,.7,0,.5.5,0,0,1,0,.71L87.1,392.75A.51.51,0,0,1,86.74,392.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.45,
    y: 229.66,
    width: 18.36,
    height: 20.46,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.81,250.62H26.45a.51.51,0,0,1-.5-.5V229.66a.5.5,0,0,1,.5-.5H44.81a.5.5,0,0,1,.5.5v20.46A.5.5,0,0,1,44.81,250.62Zm-17.86-1H44.31V230.16H27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "35.63 234.27 30.45 243.25 40.82 243.25 35.63 234.27",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.82,243.75H30.45A.5.5,0,0,1,30,243l5.19-9a.5.5,0,0,1,.43-.25h0a.49.49,0,0,1,.43.25l5.19,9a.5.5,0,0,1,0,.5A.48.48,0,0,1,40.82,243.75Zm-9.51-1H40l-4.32-7.48Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-335"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M317.59,302.22s-2.81,5.06,7.58,43c4.54,16.55,6.74,29.49,6.74,29.49A177.84,177.84,0,0,0,333,404.16c2,14.89,5.33,47.46,5.33,47.46l.85,8.43,9.26-1.13s3.37-41.28,3.65-52.23,1.41-23.59,1.41-31.73-1.41-49.15-1.41-49.15,5.34,44.37,5.62,47.18,1.69,38.19,1.69,38.19l3.08,44.37,7.87.28s7.58-29.2,8.7-41.28-2-28.92-2-31.73,11.79-55.32,12.35-67.12.28-13.76.28-13.76L319,296.32Z",
    style: {
      fill: "#7d7d7d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.22,460.55a.49.49,0,0,1-.5-.45l-.84-8.43c0-.32-3.4-32.74-5.34-47.44a181.7,181.7,0,0,1-1.13-29.53c-.16-.93-2.39-13.58-6.72-29.38-9.76-35.63-7.91-42.44-7.57-43.26l1.39-5.85a.49.49,0,0,1,.53-.38l70.76,5.61a.5.5,0,0,1,.46.43c0,.08.28,2.15-.28,13.85-.36,7.62-5.29,31.67-8.89,49.24-1.86,9.07-3.46,16.91-3.46,17.86,0,.72.23,2.54.52,4.85.85,6.75,2.27,18,1.44,26.93-1.11,12-8.64,41.07-8.72,41.36a.5.5,0,0,1-.5.37l-7.86-.28a.49.49,0,0,1-.48-.46l-3.09-44.37c0-.37-1.41-35.42-1.69-38.18-.18-1.86-2.63-22.31-4.23-35.67.41,12.79,1,32.27,1,37.59,0,4.39-.33,10.07-.67,16.09-.3,5.21-.61,10.59-.74,15.65C352.36,417.54,349,458.55,349,459a.5.5,0,0,1-.44.46l-9.26,1.12ZM318,302.45c-.12.25-2.42,6,7.62,42.61,4.49,16.39,6.72,29.4,6.75,29.53a.4.4,0,0,1,0,.11,181.07,181.07,0,0,0,1.12,29.4c2,14.72,5.31,47.15,5.34,47.47l.79,7.92,8.36-1c.35-4.33,3.35-41.57,3.61-51.8.13-5.08.44-10.47.74-15.69.34-6,.67-11.67.67-16,0-8-1.39-48.72-1.41-49.13a.51.51,0,0,1,.47-.52.5.5,0,0,1,.53.44c.05.45,5.34,44.41,5.62,47.19s1.63,36.78,1.69,38.22L363,455.07l7,.25c.9-3.5,7.56-29.67,8.6-40.81.81-8.79-.6-20-1.44-26.71-.31-2.44-.53-4.2-.53-5,0-1,1.26-7.2,3.48-18.06,3.6-17.53,8.52-41.55,8.88-49.08.43-9.05.36-12.27.31-13.27l-69.92-5.55-1.3,5.48S318.05,302.42,318,302.45Zm-.45-.23h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.26,329.48c-.08-2.29-.13-3.67-.13-3.67A35.8,35.8,0,0,0,352.26,329.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.26,330a.5.5,0,0,1-.5-.46,36.58,36.58,0,0,1-.13-3.73.5.5,0,0,1,.5-.48h0a.5.5,0,0,1,.5.48l.13,3.67a.51.51,0,0,1-.47.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319,296.32l-1.41,5.9s-.38.7-.34,3.48l3.24-1.15s0,2.43,9,9,21.14,9,21.14,9-16.63-1.73-14.9.35,16.39,2.89,16.39,2.89.73,6.06,1.67,13.84a102.1,102.1,0,0,0,12.09,30.06,97.63,97.63,0,0,0,11.47,15.67c-.14-1.2-.23-2.08-.23-2.56,0-2.81,11.79-55.32,12.35-67.12s.28-13.76.28-13.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.36,385.88a.5.5,0,0,1-.37-.17A97.71,97.71,0,0,1,365.46,370a102.81,102.81,0,0,1-12.15-30.2l-1.62-13.47c-2.74-.17-14.63-1-16.33-3.05a.81.81,0,0,1-.15-1c.55-1,5.23-1,9.85-.7A56.23,56.23,0,0,1,329.21,314c-6.76-4.93-8.57-7.62-9-8.76l-2.74,1a.51.51,0,0,1-.45-.06.47.47,0,0,1-.22-.4,9.6,9.6,0,0,1,.37-3.65l1.39-5.85a.49.49,0,0,1,.53-.38l70.76,5.61a.5.5,0,0,1,.46.43c0,.08.28,2.15-.28,13.85-.36,7.62-5.29,31.67-8.89,49.24-1.86,9.07-3.46,16.91-3.46,17.86,0,.52.12,1.61.23,2.5a.5.5,0,0,1-.29.51A.54.54,0,0,1,377.36,385.88Zm-41.14-63.19c1.6,1.36,10.52,2.32,15.94,2.62a.51.51,0,0,1,.47.44l1.66,13.84a101.65,101.65,0,0,0,12,29.86,98.13,98.13,0,0,0,10.37,14.42c0-.47-.06-.81-.06-1.05,0-1,1.26-7.2,3.48-18.06,3.6-17.53,8.52-41.55,8.88-49.08.43-9.05.36-12.27.31-13.27l-69.92-5.55-1.3,5.48a.61.61,0,0,1-.05.12h0a7.62,7.62,0,0,0-.28,2.53l2.57-.91a.53.53,0,0,1,.46.06.52.52,0,0,1,.21.41h0s.36,2.43,8.81,8.61c8.82,6.44,20.82,8.9,20.94,8.92a.5.5,0,0,1-.15,1C344.5,322.44,337.54,322.13,336.22,322.69Zm-18.63-20.47h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.22,460.05l9.26-1.13s1-12.28,2-25.22h-14c1.07,9.9,1.9,17.92,1.9,17.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.22,460.55a.49.49,0,0,1-.5-.45l-.84-8.43h0s-.83-8-1.91-17.91a.5.5,0,0,1,.13-.39.48.48,0,0,1,.37-.17h14a.5.5,0,0,1,.5.54c-.94,12.79-1.95,25.1-2,25.22a.5.5,0,0,1-.44.46l-9.26,1.12ZM337,434.2c1,9.65,1.84,17.37,1.84,17.37l.79,7.92,8.36-1c.18-2.2,1.05-13,1.88-24.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.39,455.83s3.13-12.07,5.67-23.9a40.38,40.38,0,0,0-15.21-.43l1.67,24.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.39,456.33h0l-7.86-.28a.49.49,0,0,1-.48-.46l-1.68-24.06a.5.5,0,0,1,.41-.52,41.11,41.11,0,0,1,15.39.43.49.49,0,0,1,.33.21.51.51,0,0,1,.07.38c-2.51,11.71-5.65,23.81-5.68,23.93A.49.49,0,0,1,370.39,456.33Zm-7.4-1.26,7,.25c.55-2.13,3.23-12.65,5.46-23a40.63,40.63,0,0,0-14.08-.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.08,448.34s-1-4.77-4.6-5.43-7.74,5.76-8.73,10a88.63,88.63,0,0,0-1.48,9.88s-3.29,0-3.29,1.81,4.11,3.62,6.75,3.95,11.19-.5,11.19-1.65S351.08,448.34,351.08,448.34Z",
    style: {
      fill: "#3010BC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.26,469.16a13.35,13.35,0,0,1-1.59-.08c-2.51-.31-7.19-2.11-7.19-4.44,0-1.64,1.92-2.2,3.34-2.3a83.86,83.86,0,0,1,1.45-9.5c1.06-4.63,5.3-11.14,9.29-10.42s5,5.62,5,5.82a.41.41,0,0,1,0,.11c0,.17-.16,17.45-.16,18.59a.86.86,0,0,1-.32.64C350,468.55,344.46,469.16,341.26,469.16Zm4.7-25.79c-3.06,0-6.79,5.66-7.72,9.69a87.71,87.71,0,0,0-1.47,9.81.5.5,0,0,1-.5.46s-2.79.06-2.79,1.31,3.61,3.11,6.31,3.45,9.81-.5,10.63-1.24c0-1.7.15-17.36.16-18.45-.11-.49-1.14-4.44-4.2-5A1.93,1.93,0,0,0,346,443.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.6,449.5l-5.26,2.3-2.55,16.85c3.54-.06,9.13-.78,9.13-1.71s.08-9.85.13-15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.79,469.15a.48.48,0,0,1-.37-.17.49.49,0,0,1-.12-.4l2.54-16.85a.52.52,0,0,1,.3-.39l5.26-2.3a.5.5,0,0,1,.63.2l1.45,2.43a.48.48,0,0,1,.07.26c-.05,4.83-.13,14.17-.13,15,0,2-9.52,2.21-9.62,2.21Zm3-17-2.41,16c3.69-.13,7.48-.8,8-1.29,0-1.26.08-10.06.13-14.79l-1.15-1.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.08,448.34s-4.93-.32-6.09,2.31c-.93,2.13.18,13.28.64,17.48a2,2,0,0,0,1.79,1.76h0a2,2,0,0,0,2.15-1.66l2.5-15.44S352.23,449.83,351.08,448.34Z",
    style: {
      fill: "#3010BC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.61,470.4h-.24a2.5,2.5,0,0,1-2.23-2.2c-.63-5.71-1.54-15.61-.6-17.74,1.27-2.92,6.36-2.62,6.58-2.6a.48.48,0,0,1,.36.19c1.25,1.61,1.1,4.65,1.09,4.78l-2.51,15.49A2.49,2.49,0,0,1,347.61,470.4Zm3-21.57c-1.21,0-4.32.19-5.12,2-.59,1.36-.33,8,.68,17.23a1.49,1.49,0,0,0,2.95.07l2.5-15.44h0a8.37,8.37,0,0,0-.76-3.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.33,448.34s1-4.77,4.6-5.43,7.74,5.76,8.73,10a88.63,88.63,0,0,1,1.48,9.88s3.29,0,3.29,1.81-4.12,3.62-6.75,3.95-11.19-.5-11.19-1.65S361.33,448.34,361.33,448.34Z",
    style: {
      fill: "#3010BC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.15,469.16c-3.2,0-8.74-.61-9.84-1.58a.86.86,0,0,1-.32-.64c0-1.14-.16-18.42-.16-18.59a.41.41,0,0,1,0-.11c0-.2,1.1-5.11,5-5.82s8.24,5.79,9.3,10.42a83.86,83.86,0,0,1,1.45,9.5c1.42.1,3.34.66,3.34,2.3,0,2.33-4.68,4.13-7.19,4.44A13.47,13.47,0,0,1,371.15,469.16ZM362,466.85c.82.74,7.91,1.58,10.63,1.24s6.31-2.11,6.31-3.45-2.77-1.31-2.79-1.31a.5.5,0,0,1-.5-.46,87.71,87.71,0,0,0-1.47-9.81c-1-4.22-5-10.23-8.15-9.65s-4.08,4.5-4.19,5C361.84,449.49,362,465.15,362,466.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.81,449.5l5.26,2.3,2.55,16.85c-3.54-.06-9.13-.78-9.13-1.71s-.08-9.85-.13-15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.62,469.15h0c-.1,0-9.62-.23-9.62-2.21,0-.88-.1-11.52-.13-15a.48.48,0,0,1,.07-.26l1.45-2.43a.5.5,0,0,1,.63-.2l5.26,2.3a.52.52,0,0,1,.3.39l2.54,16.85a.49.49,0,0,1-.12.4A.48.48,0,0,1,370.62,469.15Zm-8.63-2.3c.56.49,4.35,1.16,8,1.29l-2.41-16-4.61-2-1.15,1.93C361.89,455.59,362,465.51,362,466.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.33,448.34s4.93-.32,6.08,2.31c.94,2.13-.18,13.28-.64,17.48a2,2,0,0,1-1.78,1.76h0a2,2,0,0,1-2.15-1.66l-2.5-15.44S360.17,449.83,361.33,448.34Z",
    style: {
      fill: "#3010BC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.8,470.4a2.48,2.48,0,0,1-2.45-2.09l-2.5-15.44c0-.18-.17-3.22,1.08-4.83a.48.48,0,0,1,.36-.19c.22,0,5.3-.32,6.58,2.6.94,2.13,0,12-.6,17.74a2.5,2.5,0,0,1-2.23,2.2Zm-3.21-21.57a7.92,7.92,0,0,0-.75,3.93l2.49,15.39a1.49,1.49,0,0,0,2.95-.07c1-9.27,1.27-15.87.68-17.23C366.09,448.87,362.54,448.81,361.59,448.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.71,196.07s-26.88,12.27-28,13.66-6.26,28-5.8,30.59.47,3,.93,5.09-.46,9.27-.93,12.74.93,6,3.48,7,13.9,3,13.9,3l-11.82,33.59s16,13,45.18,10.89,34.52-8.81,34.52-8.81l-12.28-39.61A97.1,97.1,0,0,0,393,262.09c5.33-1.39,6-6,4.87-13.43a68.35,68.35,0,0,1-.47-14.83s.47-8.11-.23-11.82-5.1-13.43-6.25-15.06-27.8-10.88-28.5-11.35S342.71,196.07,342.71,196.07Z",
    style: {
      fill: "#3010BC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.4,313.32c-25.13,0-39.12-11.1-39.27-11.22a.5.5,0,0,1-.16-.56l11.62-33c-2.36-.44-11.15-2.11-13.4-2.93-2.87-1-4.29-3.84-3.8-7.48.34-2.59,1.4-10.49.93-12.57-.29-1.3-.4-2-.55-2.92-.09-.56-.2-1.23-.38-2.2-.47-2.56,4.66-29.5,5.9-31s23.71-11.74,28.21-13.8a.39.39,0,0,1,.18,0c8.74-.43,19.31-.84,20-.38.26.14,2.9,1.11,5.95,2.22,14.12,5.18,21.91,8.19,22.67,9.25,1.27,1.77,5.64,11.51,6.34,15.26s.26,11.6.24,11.94a68.57,68.57,0,0,0,.46,14.72c1,6.3,1,12.36-5.23,14a98.18,98.18,0,0,1-10.6,2l12.11,39a.49.49,0,0,1-.09.45c-.22.29-5.8,6.92-34.87,9C357.5,313.25,355.42,313.32,353.4,313.32ZM315,301.53c2.24,1.66,17.95,12.47,44.55,10.57,25.8-1.84,32.85-7.37,34-8.44l-12.19-39.33a.51.51,0,0,1,.06-.42.49.49,0,0,1,.36-.23,98.23,98.23,0,0,0,11.05-2.07c4.51-1.17,5.77-4.78,4.5-12.88a70.32,70.32,0,0,1-.47-14.95c0-.06.46-8.07-.22-11.67-.7-3.76-5.11-13.38-6.17-14.86-.9-1.09-15.29-6.36-22.21-8.9-4.46-1.63-5.92-2.18-6.16-2.33-.85-.24-12.25.2-19.29.54-10.3,4.71-26.86,12.5-27.77,13.5-1.17,1.57-6.12,27.79-5.68,30.17.17,1,.28,1.64.38,2.21.15.92.25,1.59.54,2.86.45,2-.31,8.34-.92,12.92-.42,3.15.76,5.54,3.15,6.41s13.71,3,13.82,3a.51.51,0,0,1,.34.25.49.49,0,0,1,0,.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.77,256.31s-41,10-36.66,10.51,31.53-2.05,35.38-2.82,1-4.87,1-4.87,6.67-1.28,4.62-3.33S369.77,256.31,369.77,256.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.86,264.68a.5.5,0,0,1-.48-.37l-1.62-5.79a.65.65,0,0,1,0-.2l3.57-28.7a.5.5,0,0,1,1,.13l-3.55,28.6,1.59,5.69a.5.5,0,0,1-.34.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.37,225.63h-.06a.51.51,0,0,1-.44-.56l.51-4a.49.49,0,0,1,.55-.43.5.5,0,0,1,.44.56l-.5,4A.51.51,0,0,1,384.37,225.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.26,268.62l-.14,0a.5.5,0,0,1-.34-.62l2.75-9.39-2.38-12.35a.5.5,0,0,1,.4-.58.51.51,0,0,1,.59.39l2.39,12.47a.49.49,0,0,1,0,.24l-2.78,9.5A.51.51,0,0,1,326.26,268.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.84,242.47a.5.5,0,0,1-.49-.4l-3.52-18.34a.51.51,0,0,1,.4-.59.5.5,0,0,1,.58.4l3.52,18.34a.49.49,0,0,1-.39.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.91,253.88s-4.34,1.36-4.09,2.48,4.22,3,4.71,3.1.51-.84.51-.84Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.62,260l-.21,0c-.41-.11-4.75-2-5.08-3.48s2.65-2.51,4.43-3.07a.5.5,0,0,1,.4,0,.51.51,0,0,1,.24.32l1.13,4.74a.49.49,0,0,1,0,.12,1.6,1.6,0,0,1-.45,1.19A.74.74,0,0,1,328.62,260Zm0-1h0Zm-1.11-4.46c-1.69.59-3.17,1.38-3.24,1.75.15.66,3.25,2.31,4.19,2.66a2.34,2.34,0,0,0,0-.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.81,257.35s-1.86,2.86-1.12,3.35a44.8,44.8,0,0,0,4.22,1.86l1.13-3.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.91,263.06a.57.57,0,0,1-.18,0,41.79,41.79,0,0,1-4.31-1.91c-1-.64,0-2.55,1-4a.5.5,0,0,1,.56-.21l4.23,1.27a.5.5,0,0,1,.34.61l-1.13,3.95a.46.46,0,0,1-.25.31A.46.46,0,0,1,327.91,263.06ZM325,257.94a5.74,5.74,0,0,0-1,2.41c.45.27,2.41,1.08,3.57,1.55l.83-2.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.81,261.2s-1.49.74-.12,2.11a8.76,8.76,0,0,0,2.6,1.86l.62-2.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.29,265.67a.39.39,0,0,1-.18,0,9.16,9.16,0,0,1-2.78-2,2,2,0,0,1-.7-1.68,1.82,1.82,0,0,1,1-1.23.51.51,0,0,1,.42,0l3.11,1.37a.49.49,0,0,1,.28.57l-.62,2.61a.51.51,0,0,1-.26.33A.59.59,0,0,1,327.29,265.67Zm-2.43-3.9a.66.66,0,0,0-.24.38c-.05.27.2.59.42.81a9.82,9.82,0,0,0,1.91,1.48l.38-1.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.69,263.31a4.83,4.83,0,0,0,.74,2.36,5.86,5.86,0,0,0,1.37,1l.49-1.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.8,267.16a.59.59,0,0,1-.23-.05,6.74,6.74,0,0,1-1.49-1.09,5.06,5.06,0,0,1-.89-2.68.49.49,0,0,1,.25-.47.52.52,0,0,1,.54,0l2.6,1.86a.51.51,0,0,1,.19.57l-.5,1.49a.47.47,0,0,1-.28.3A.43.43,0,0,1,326.8,267.16Zm-1.42-2.74a2.05,2.05,0,0,0,.41.89,4.6,4.6,0,0,0,.73.6l.18-.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.14,253.9s4.9,1.34,4.66,2.46-4.22,3-4.72,3.1-1-1.55-1-1.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381,260c-.69,0-1.16-1-1.44-1.91a.53.53,0,0,1,0-.28l1.09-4a.47.47,0,0,1,.23-.3.51.51,0,0,1,.38-.05c2.45.67,5.3,1.74,5,3.05-.32,1.47-4.66,3.37-5.08,3.48Zm-.44-2.07a4,4,0,0,0,.5,1c.89-.32,4.07-2,4.23-2.69-.13-.35-1.85-1.14-3.82-1.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.8,257.35s1.86,2.86,1.12,3.35a44.8,44.8,0,0,1-4.22,1.86l-1.13-3.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.7,263.06a.42.42,0,0,1-.22-.05.48.48,0,0,1-.26-.31l-1.13-3.95a.5.5,0,0,1,.34-.61l4.23-1.27a.5.5,0,0,1,.56.21c1,1.49,1.93,3.4,1,4a42.82,42.82,0,0,1-4.32,1.91A.57.57,0,0,1,381.7,263.06Zm-.51-4.1.84,2.94a37.72,37.72,0,0,0,3.61-1.61,7.44,7.44,0,0,0-1.06-2.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.8,261.2s1.49.74.13,2.11a8.87,8.87,0,0,1-2.61,1.86l-.62-2.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.32,265.67a.59.59,0,0,1-.23-.05.54.54,0,0,1-.26-.33l-.62-2.61a.51.51,0,0,1,.29-.57l3.1-1.37a.54.54,0,0,1,.43,0,1.84,1.84,0,0,1,1,1.23,1.93,1.93,0,0,1-.7,1.68,9.19,9.19,0,0,1-2.77,2A.43.43,0,0,1,382.32,265.67Zm0-2.82.38,1.59a9.53,9.53,0,0,0,1.91-1.48c.22-.22.47-.54.43-.81a.67.67,0,0,0-.25-.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.93,263.31a4.87,4.87,0,0,1-.75,2.36,5.92,5.92,0,0,1-1.36,1l-.5-1.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.82,267.16a.41.41,0,0,1-.19,0,.48.48,0,0,1-.29-.3l-.49-1.49a.5.5,0,0,1,.18-.57l2.6-1.86a.52.52,0,0,1,.54,0,.49.49,0,0,1,.25.47,5,5,0,0,1-.88,2.68,6.68,6.68,0,0,1-1.5,1.09A.59.59,0,0,1,382.82,267.16Zm.09-1.8.18.55a4.24,4.24,0,0,0,.74-.6,2.18,2.18,0,0,0,.4-.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.36,255.79a.58.58,0,0,1-.18,0,49.06,49.06,0,0,1-9.24-4.85.5.5,0,1,1,.58-.82,47.35,47.35,0,0,0,9,4.74.5.5,0,0,1-.19,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.71,253.32a18.14,18.14,0,0,1-7-1.69.5.5,0,0,1,.39-.92c4.58,2,7.24,1.57,7.26,1.57a.51.51,0,0,1,.58.41.51.51,0,0,1-.41.58A7.05,7.05,0,0,1,393.71,253.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.45,258.07a.5.5,0,0,1-.06-1c5.23-.65,10.15-5.95,10.2-6a.5.5,0,0,1,.7,0,.5.5,0,0,1,0,.71c-.21.23-5.21,5.63-10.81,6.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.13,254.19a.5.5,0,0,1-.49-.46.49.49,0,0,1,.45-.54c2.46-.23,7-1.13,7-1.14a.51.51,0,0,1,.59.4.5.5,0,0,1-.4.58c-.18,0-4.62.93-7.13,1.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.47,173.52s-4.13-1.52-2.83,5.22,6.53,6.74,6.53,6.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.17,186c-.06,0-5.65-.08-7-7.14-.52-2.71-.26-4.52.78-5.41a2.93,2.93,0,0,1,2.71-.38.49.49,0,0,1,.31.32l3.7,12a.5.5,0,0,1-.08.44A.48.48,0,0,1,340.17,186Zm-4.61-12.11a1.48,1.48,0,0,0-1,.33c-.51.43-1,1.56-.44,4.45.94,4.84,3.95,6,5.33,6.25l-3.39-11A2.3,2.3,0,0,0,335.56,173.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370,172.21s3.26,1.31,2,5.23-6.75,8-6.75,8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.18,186a.5.5,0,0,1-.47-.67L369.5,172a.5.5,0,0,1,.66-.29s3.68,1.53,2.24,5.84c-1.34,4-6.69,8.12-6.91,8.29A.5.5,0,0,1,365.18,186Zm5.06-13-4,11c1.67-1.48,4.34-4.14,5.17-6.64S371,173.43,370.24,172.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351,149.37s-7.61,0-10.22,2.61-5.87,10.45-5.66,16.32,3,14.79,7,19.58S354.31,194,359.31,192s10.23-15.23,10.66-19.8-.22-12.4-4.57-18.7S356.7,144.15,351,149.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.19,193.38c-4.52,0-9.58-1.67-12.45-5.19-4.1-5-6.87-14.22-7.07-19.87-.22-5.82,3-13.89,5.8-16.69,2.51-2.52,9.13-2.74,10.38-2.75,2.21-2,4.32-2.87,6.43-2.63,2.79.31,5.42,2.46,8.53,7,4.19,6.08,5.15,13.82,4.66,19-.45,4.66-5.74,18.17-11,20.22A14.91,14.91,0,0,1,354.19,193.38Zm2.42-46.17c-1.67,0-3.39.83-5.23,2.53a.46.46,0,0,1-.33.13c-.08,0-7.44,0-9.88,2.47-2.66,2.66-5.71,10.37-5.5,15.94s2.87,14.43,6.84,19.28c3.83,4.68,11.83,5.86,16.62,4s9.93-15,10.34-19.37c.48-5-.44-12.52-4.48-18.38-2.89-4.19-5.38-6.27-7.82-6.54A3.52,3.52,0,0,0,356.61,147.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.56,178.31s-12.4,25-10.22,38.28,9.35,17,9.79,20.45-5.22,2.39-2,11.09,10.66,11.32,9.79,13.71-5,1.09-5,1.09a6.47,6.47,0,0,0,7.61,3.91c5.87-1.09,8.27-6.74,8.05-12.83s-3.26-12-2.18-14.36,6.75-9.14,6.75-18.06-5.22-30.89-9.36-42.85S351.26,157.2,347.56,178.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356,267.5a7,7,0,0,1-6.48-4.41.5.5,0,0,1,.12-.51.49.49,0,0,1,.51-.13s3.68,1.13,4.38-.78c.26-.72-.89-1.78-2.34-3.13a26.36,26.36,0,0,1-7.45-10.23c-2.19-5.84-.5-7.56.85-8.95.7-.71,1.21-1.23,1.08-2.26s-1-2.22-2.28-3.83a33.51,33.51,0,0,1-7.5-16.6c-2.14-13.07,9.39-36.8,10.23-38.52,1.51-8.53,3.34-12.6,5.78-12.79s5.26,4,8.45,13.22c4.25,12.3,9.38,34.23,9.38,43,0,7.18-3.52,12.86-5.62,16.25a22.8,22.8,0,0,0-1.17,2c-.5,1.1.07,3.32.74,5.89a39.05,39.05,0,0,1,1.48,8.24c.2,5.66-1.91,12.13-8.46,13.34A8.66,8.66,0,0,1,356,267.5Zm-5.09-3.85a5.93,5.93,0,0,0,6.61,2.7c5.92-1.1,7.83-7.09,7.64-12.33a37.78,37.78,0,0,0-1.45-8c-.74-2.87-1.33-5.13-.68-6.56a22.36,22.36,0,0,1,1.23-2.13c2-3.3,5.47-8.82,5.47-15.72,0-8.69-5.1-30.46-9.33-42.69-3.65-10.57-6-12.67-7.42-12.55-1.05.09-3.08,1.76-4.88,12a.78.78,0,0,1-.05.14c-.12.25-12.3,25-10.18,38a32.69,32.69,0,0,0,7.31,16.15c1.35,1.73,2.32,3,2.49,4.32a3.48,3.48,0,0,1-1.36,3.08c-1.22,1.25-2.6,2.66-.63,7.9a25.09,25.09,0,0,0,7.19,9.85c1.79,1.66,3.09,2.86,2.6,4.2C354.71,264,352.29,263.9,350.87,263.65Zm-3.31-85.34h0Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-335"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "138.05 178.78 138.76 193.22 163.43 191.46 162.19 177.37 138.05 178.78",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.76,193.72a.5.5,0,0,1-.33-.12.53.53,0,0,1-.17-.35l-.71-14.45a.5.5,0,0,1,.47-.52l24.15-1.41a.48.48,0,0,1,.52.45l1.24,14.1a.5.5,0,0,1-.12.37.51.51,0,0,1-.35.17l-24.67,1.76Zm-.18-14.47.65,13.44L162.89,191l-1.15-13.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.28,145.47a12.34,12.34,0,0,0-4.94,1.94c-2.81,1.76-6.87,8.28-6.69,10.22s3.7,19.91,4.4,21.15,4.06,6.16,10,6.34a24,24,0,0,0,10.57-1.94c.88-.35,4.05-5.11,4.76-7.58s.17-21.49-.88-24.14-6.35-8.28-8.81-9S146.16,143.71,145.28,145.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.93,185.63h-.85c-6.62-.2-10.09-5.94-10.46-6.6-.81-1.42-4.32-19.66-4.47-21.34-.2-2.25,4.13-9,6.93-10.69a13.33,13.33,0,0,1,4.89-2c1.31-2,6.4-3.73,8.9-3,2.65.76,8,6.49,9.14,9.29s1.6,22,.9,24.46-3.9,7.45-5,7.9l-.23.1A24.24,24.24,0,0,1,148.93,185.63Zm3.58-42.81c-2.47,0-6.14,1.58-6.78,2.87a.53.53,0,0,1-.41.28,12,12,0,0,0-4.71,1.86c-2.84,1.78-6.61,8.15-6.46,9.75.21,2.33,3.74,19.9,4.34,20.95.34.6,3.55,5.91,9.62,6.09a23.57,23.57,0,0,0,10.13-1.8l.24-.1c.7-.32,3.76-4.79,4.47-7.25.63-2.23.18-21.21-.87-23.82s-6.15-8-8.48-8.69A3.69,3.69,0,0,0,152.51,142.82Zm-7.23,2.65h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.06,164.85a2.89,2.89,0,0,0-2.47,3c-.17,2.82,4.58,7.58,4.58,7.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.17,175.93a.49.49,0,0,1-.35-.15c-.2-.2-4.92-4.95-4.73-8a3.39,3.39,0,0,1,2.93-3.46.49.49,0,0,1,.53.4l2.11,10.57a.5.5,0,0,1-.25.54A.53.53,0,0,1,137.17,175.93Zm-2.5-10.48a2.46,2.46,0,0,0-1.58,2.43c-.1,1.62,1.78,4.19,3.24,5.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.43,162.74s3.35-.88,3.52,2.64-3,6.52-3,6.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,172.4a.63.63,0,0,1-.19,0,.49.49,0,0,1-.31-.44l-.53-9.16a.5.5,0,0,1,.37-.51,3.81,3.81,0,0,1,2.94.45,3.32,3.32,0,0,1,1.21,2.65c.19,3.71-3,6.78-3.15,6.91A.48.48,0,0,1,164,172.4Zm0-9.24.44,7.51a8.33,8.33,0,0,0,2.06-5.26,2.34,2.34,0,0,0-.8-1.89A2.58,2.58,0,0,0,164,163.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165,189.71s-3.61-2.82-5.42-3-18.49.2-20.5,1.21-4.21,5.82-4.21,5.82l31.34-1.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.89,194.22a.53.53,0,0,1-.42-.21.51.51,0,0,1,0-.49c.09-.21,2.31-5,4.45-6.07s18.93-1.46,20.77-1.26,5.3,2.82,5.68,3.12a.51.51,0,0,1,.13.16l1.21,2.21a.48.48,0,0,1,0,.48.48.48,0,0,1-.4.25l-31.35,1.81Zm22.62-7.08c-4.95,0-16.63.43-18.18,1.2-1.28.64-2.82,3.25-3.62,4.84l29.7-1.72-.78-1.42c-1-.8-3.76-2.7-5.09-2.85C159.22,187.15,158.5,187.14,157.51,187.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.15,189.71s-12.85.4-14.06,2.21-8,7.43-8,7.43l43.6-2.41s-5.42-6.83-6.63-7.23S150.15,189.71,150.15,189.71Z",
    style: {
      fill: "#3010BC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.05,199.85a.5.5,0,0,1-.31-.89c.06-.05,6.78-5.6,7.93-7.32,1.29-1.93,12.28-2.37,14.47-2.43h0c2.3-.07,13.81-.39,15,0s5.57,5.77,6.86,7.4a.5.5,0,0,1,.07.51.51.51,0,0,1-.43.3l-43.6,2.41Zm22.12-9.64c-6.19.19-13,1-13.66,2-.94,1.4-5,4.87-7,6.58l41.12-2.28c-2.47-3.06-5.17-6.1-5.79-6.31-.81-.27-9.44-.13-14.69,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.17,315.07s3.21,16.28,4.42,17.68a49.26,49.26,0,0,0,7.63,6.23c1,.4,4.42.2,4.42.2l-3.21-22.9-4.82-2.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.84,339.73a9.16,9.16,0,0,1-2.8-.29c-1.18-.46-6.68-5-7.83-6.36s-4-15.17-4.53-17.91a.49.49,0,0,1,.08-.39.5.5,0,0,1,.34-.2l8.44-1.21a.49.49,0,0,1,.29.05l4.82,2.41a.49.49,0,0,1,.27.38l3.22,22.9a.5.5,0,0,1-.47.57C125.51,339.69,124.73,339.73,123.84,339.73Zm-14.08-24.24c1.25,6.28,3.41,16,4.21,16.94a50.41,50.41,0,0,0,7.44,6.09,13.89,13.89,0,0,0,3.66.19l-3.1-22.1-4.45-2.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.58,213s-9,48.82-9.24,56.46,6.23,48,6.23,48a20.26,20.26,0,0,0,4.82.61c2.61,0,5.82-2.41,5.82-2.41L122,273.89l-7-59.47Z",
    style: {
      fill: "#3010BC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.39,318.59a21.3,21.3,0,0,1-5-.62.51.51,0,0,1-.36-.41c-.26-1.65-6.43-40.51-6.23-48.11s8.88-54.54,9.25-56.53a.51.51,0,0,1,.25-.35.5.5,0,0,1,.43,0l3.42,1.41a.49.49,0,0,1,.3.4l7,59.47-2.81,41.88a.51.51,0,0,1-.2.37C119.38,316.18,116.13,318.59,113.39,318.59ZM109,317.08a20.31,20.31,0,0,0,4.38.51c2.07,0,4.64-1.69,5.34-2.18l2.8-41.56-7-59.08L112,213.71c-1,5.64-8.94,48.72-9.12,55.77S108.4,313.21,109,317.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.44,270.12c-.87,3.2-8.83,3.19-13,3,1,12.41,6.08,44.4,6.08,44.4a20.26,20.26,0,0,0,4.82.61c2.61,0,5.82-2.41,5.82-2.41L122,273.89l-3.39-28.64-1.22.78S116.63,265.78,115.44,270.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.39,318.59a21.3,21.3,0,0,1-5-.62.51.51,0,0,1-.36-.41c0-.32-5.11-32.15-6.07-44.45a.46.46,0,0,1,.14-.38.44.44,0,0,1,.38-.15c7.24.4,11.89-.57,12.44-2.59,1.16-4.24,2-23.78,2-24a.48.48,0,0,1,.23-.4l1.22-.78a.53.53,0,0,1,.49,0,.52.52,0,0,1,.28.4l3.38,28.63-2.81,41.88a.51.51,0,0,1-.2.37C119.38,316.18,116.13,318.59,113.39,318.59ZM109,317.08a20.31,20.31,0,0,0,4.38.51c2.07,0,4.64-1.69,5.34-2.18l2.8-41.56-3.29-27.75-.34.21c-.1,2.46-.85,19.82-2,23.94h0c-.87,3.21-7.36,3.61-12.88,3.35C104.05,285.54,108.48,313.71,109,317.08Zm6.43-47h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200,315.07s-3.21,16.28-4.42,17.68a49.73,49.73,0,0,1-7.63,6.23c-1,.4-4.42.2-4.42.2l3.21-22.9,4.82-2.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.31,339.73c-.89,0-1.67,0-1.83-.05a.5.5,0,0,1-.47-.57l3.21-22.9a.52.52,0,0,1,.28-.38l4.82-2.41a.49.49,0,0,1,.29-.05l8.44,1.21a.5.5,0,0,1,.34.2.49.49,0,0,1,.08.39c-.54,2.74-3.3,16.47-4.53,17.91s-6.66,5.9-7.83,6.36A9.2,9.2,0,0,1,185.31,339.73Zm-1.23-1a14.31,14.31,0,0,0,3.66-.19,50.93,50.93,0,0,0,7.44-6.09c.79-.93,2.95-10.66,4.21-16.94l-7.76-1.11-4.45,2.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.35,211.2s6.63,47.62,8.43,55.25-.2,51.64-.2,51.64a14.49,14.49,0,0,1-5.62,0,16.07,16.07,0,0,1-6-2.82s-8.24-50.22-8.24-52.84S192.35,211.2,192.35,211.2Z",
    style: {
      fill: "#3010BC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.85,318.86a16.14,16.14,0,0,1-3-.28,16.5,16.5,0,0,1-6.24-2.91.49.49,0,0,1-.18-.32c-.34-2.05-8.25-50.29-8.25-52.92s11.19-49.36,11.67-51.34a.5.5,0,0,1,.51-.39.5.5,0,0,1,.47.43c.07.48,6.65,47.68,8.43,55.21s-.11,50-.19,51.77a.49.49,0,0,1-.38.46A12.18,12.18,0,0,1,197.85,318.86ZM189.39,315a15.4,15.4,0,0,0,5.66,2.6,14.58,14.58,0,0,0,5,.08c.19-4.38,1.88-44,.2-51.1-1.55-6.53-6.67-42.6-8.08-52.68-4.14,17.31-11,46.62-11,48.54S186.54,297.58,189.39,315Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195,318.09a14.49,14.49,0,0,0,5.62,0s1.72-37.73.54-49.37c-2.88,2-7.61,5.09-9.47,4.56-2.76-.79-11-10.85-11-10.85,0,2.62,8.24,52.84,8.24,52.84A16.07,16.07,0,0,0,195,318.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.85,318.86a16.14,16.14,0,0,1-3-.28,16.5,16.5,0,0,1-6.24-2.91.49.49,0,0,1-.18-.32c-.34-2.05-8.25-50.29-8.25-52.92a.5.5,0,0,1,.89-.31c2.25,2.76,8.57,10.07,10.71,10.68,1.21.33,4.59-1.34,9-4.49a.53.53,0,0,1,.5-.05.51.51,0,0,1,.29.41c1.17,11.54-.52,49.06-.54,49.44a.49.49,0,0,1-.38.46A12.18,12.18,0,0,1,197.85,318.86ZM189.39,315a15.4,15.4,0,0,0,5.66,2.6h0a14.59,14.59,0,0,0,5,.08c.17-3.94,1.55-36.38.6-48.05-4.58,3.18-7.67,4.58-9.18,4.14-2.33-.66-7.79-6.92-10.16-9.74C182.28,271.17,186.83,299.39,189.39,315Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.43,316.28s7,63.69,7,65.09-2.61,12.26-1.81,18.49,5.43,36,5.43,36-1,4.62-.81,6.23,2.21,8,2.21,8-4.22,7.64-4.82,8.84-3.41,1.21-1.81,3.82,14.27,6.23,16.28,6.63,6.23.8,6.83-2-.4-13.26-.4-13.26a22.15,22.15,0,0,0,1.6-6.63c.2-3.41-1.8-7.23-1.8-10.24s1.6-34.16,1.2-41.79-1.41-19.89-1.41-19.89l4.22-55.25,4.83,7.43L165.83,379s1.2,15.87,3.21,23.11,5.63,43.79,5.63,43.79.6,4.42,1,7,1.21,14.86,1.61,15.67,6.83,2.41,9.64,2,11.85-1.21,13.26-1.61,4.62-.8,6-4.42-2.41-3.22-4.42-4.22-4.22-4.42-4.82-5.22-1.81-1.61-2-2.82a26.4,26.4,0,0,0-1.21-5.42l-2.41-4.82s.6-45.41.6-46.81-1.8-22.71-1.8-22.71l-1.21-57.26S151.36,299,152,298.6,122.43,316.28,122.43,316.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186,471.13c-3.14,0-8.62-1.32-9.13-2.34-.25-.49-.51-3.24-1-9-.26-3-.5-5.77-.66-6.86-.41-2.61-1-7-1-7,0-.38-3.64-36.62-5.61-43.73s-3.22-23-3.23-23.2l-6.62-51.09-4-6.1-4.11,53.77c0,.05,1,12.28,1.41,19.83.28,5.41-.44,22.78-.88,33.15-.18,4.35-.32,7.79-.32,8.67a18.32,18.32,0,0,0,.84,4.42,18.38,18.38,0,0,1,1,5.85,22.41,22.41,0,0,1-1.59,6.68c.11,1.26,1,10.57.38,13.29-.74,3.45-5.87,2.7-7.42,2.39-1.1-.22-14.78-3.9-16.6-6.86-1.35-2.19,0-3,.91-3.58a2.33,2.33,0,0,0,.87-.72c.56-1.11,4.07-7.47,4.73-8.67-.35-1.13-2-6.43-2.16-7.92s.64-5.62.79-6.31c-.29-1.82-4.64-29.89-5.41-35.88-.6-4.65.63-11.62,1.37-15.78.23-1.31.43-2.44.43-2.77,0-1.16-4.6-43.05-7-65a.5.5,0,0,1,.24-.48L136.94,307l10.15-6.09c2.54-1.51,3.79-2.26,4.45-2.58a.54.54,0,0,1,.15-.15l0,.06c.49-.21.55-.11.67.08l0,0c1.79,1.19,22.77,10.42,36.72,16.46a.5.5,0,0,1,.3.45l1.21,57.26c.07.84,1.8,21.3,1.8,22.72s-.56,44.08-.6,46.69l2.36,4.72a21.27,21.27,0,0,1,1.15,4.93l.1.63a3.71,3.71,0,0,0,1.21,1.81,10.11,10.11,0,0,1,.71.79l.34.48c.81,1.13,2.68,3.78,4.3,4.59a9.16,9.16,0,0,0,1.7.56c1.24.32,2.53.65,3.07,1.7a3.11,3.11,0,0,1-.11,2.59c-1.34,3.46-4.27,4.19-5.84,4.59l-.51.13c-.9.26-4.53.64-8,1-2.16.23-4.2.45-5.29.6A7.94,7.94,0,0,1,186,471.13Zm-10.8-25.31s.6,4.4,1,7c.18,1.12.42,3.94.67,6.92.29,3.42.69,8.09.9,8.62.54.59,6.48,2.1,9.12,1.72,1.1-.16,3.15-.37,5.32-.61,3.31-.35,7.06-.75,7.87-1l.54-.14c1.5-.38,4-1,5.16-4a2.3,2.3,0,0,0,.15-1.78c-.34-.64-1.4-.92-2.43-1.18a10.33,10.33,0,0,1-1.9-.63c-1.84-.92-3.75-3.62-4.66-4.91l-.33-.46a7.74,7.74,0,0,0-.63-.69,4.63,4.63,0,0,1-1.48-2.34l-.1-.64a21.92,21.92,0,0,0-1.06-4.65l-2.41-4.82a.59.59,0,0,1,0-.23c0-.45.6-45.42.6-46.8s-1.78-22.45-1.8-22.67l-1.2-57c-28.15-12.19-34.85-15.42-36.46-16.43-2.21,1.29-19.48,11.65-29,17.37.6,5.42,7,63.45,7,64.83a24.61,24.61,0,0,1-.45,2.94c-.68,3.84-1.94,11-1.36,15.48.79,6.15,5.37,35.66,5.42,35.95a.61.61,0,0,1,0,.19,28.71,28.71,0,0,0-.8,6.05c.19,1.55,2.17,7.89,2.19,7.95a.51.51,0,0,1,0,.4c0,.07-4.22,7.63-4.81,8.82a3,3,0,0,1-1.25,1.12c-.9.56-1.4.87-.58,2.21,1.38,2.24,13.21,5.85,15.95,6.4,1.32.27,5.69.93,6.24-1.62.58-2.71-.4-13-.41-13.11a.43.43,0,0,1,0-.25,21.91,21.91,0,0,0,1.56-6.46,18,18,0,0,0-.92-5.53,18.33,18.33,0,0,1-.88-4.68c0-.9.13-4.18.32-8.71.44-10.36,1.16-27.7.88-33.06-.4-7.54-1.39-19.75-1.4-19.87l4.21-55.33a.5.5,0,0,1,.38-.45.49.49,0,0,1,.54.21l4.82,7.44a.49.49,0,0,1,.08.21l6.63,51.23c0,.18,1.23,15.93,3.2,23s5.49,42.39,5.64,43.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.05,199.35S111.58,211.2,111.58,213s8.64,57.66,8.64,57.66l-2.81,46.21s9,5,17.88,6.63a120.62,120.62,0,0,0,16.47,1.81l2.81-12.66,2.21,13.06s17.68-2.21,23.71-4.22a64.74,64.74,0,0,0,12.06-5.82L182.5,265.25l9.85-54.05-20.7-14.26Z",
    style: {
      fill: "#3010BC"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.78,326.22a.49.49,0,0,1-.49-.42l-1.78-10.53-2.26,10.16a.5.5,0,0,1-.5.39A121.7,121.7,0,0,1,135.2,324c-8.82-1.6-17.95-6.63-18-6.68a.53.53,0,0,1-.25-.47l2.81-46.15c-.46-2.95-8.64-55.88-8.64-57.69s11.67-10.46,16.68-14.07a.51.51,0,0,1,.27-.09l43.59-2.41a.46.46,0,0,1,.32.09l20.69,14.26a.51.51,0,0,1,.21.5l-9.83,54,10,50.34a.5.5,0,0,1-.23.52A65.42,65.42,0,0,1,180.65,322c-6,2-23.08,4.15-23.8,4.24Zm-2.21-14.06h0a.5.5,0,0,1,.48.42l2.13,12.58c2.85-.37,17.77-2.35,23.13-4.13a63.39,63.39,0,0,0,11.66-5.6l-10-50.09a.54.54,0,0,1,0-.18l9.79-53.73-20.29-14-43.28,2.39c-7.77,5.59-15.9,12-16.15,13.2,0,1.37,5.65,38.25,8.63,57.56a.34.34,0,0,1,0,.1l-2.8,45.89c1.58.84,9.65,5,17.46,6.43a121.5,121.5,0,0,0,16,1.78l2.73-12.25A.49.49,0,0,1,154.57,312.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.58,274.79a.5.5,0,0,1-.14-1L172.31,269a.5.5,0,0,1,.29.95l-15.87,4.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.24,267.26l-29.13,6.63L169.54,263s-34.75,10.66-43,9.08,42.64-30.79,42.64-30.79,16.59-2,9.88,8.68-1.19,11.85-1.19,11.85C174.77,265.28,169.24,267.26,169.24,267.26Z",
    style: {
      fill: "#263238"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEscada);
export default __webpack_public_path__ + "static/media/escada.45567a6a57f1039d793fe99b3aec9d5b.svg";
export { ForwardRef as ReactComponent };